import { IonSkeletonText } from "@ionic/react";
import { useQuery } from "@tanstack/react-query";
import { DateTime } from "luxon";

import { currentAndNextAcademicYear } from "~components/Molecules/SchoolProfile/SchoolClosures/utils";
import { fetchInsightsData, translate } from "~utils";

import { DistrictInsightSection } from "./DistrictInsightSection";

export function Insights() {
  const now = DateTime.now();

  const [currentYear, nextYear] = currentAndNextAcademicYear(now);

  const start = currentYear.startDate.toFormat("yyyy-MM-dd");
  const end = currentYear.endDate.toFormat("yyyy-MM-dd");

  const { data, isLoading, error } = useQuery({
    queryKey: ["insights"],
    queryFn: async () => {
      const { data } = await fetchInsightsData({ start, end });
      return data;
    },
  });

  if (error) {
    return <div>Something went wrong. Please contact support.</div>;
  }

  if (isLoading || !data) {
    return (
      <div css={{ padding: 8, display: "flex", flexDirection: "column", gap: 8 }}>
        {Array.from({ length: 3 }).map((_, i) => (
          <IonSkeletonText key={i} animated css={{ height: 40 }} />
        ))}
        <div css={{ textAlign: "center" }}>Hang tight, we're loading your insights.</div>
        {Array.from({ length: 3 }).map((_, i) => (
          <IonSkeletonText key={i} animated css={{ height: 40 }} />
        ))}
      </div>
    );
  }

  return (
    <div>
      <div css={{ padding: "24px 0" }}>
        <h2 css={{ margin: 0 }}>
          {`${currentYear.startDate.year.toString().substring(2, 4)}-${nextYear.startDate.year.toString().substring(2, 4)} ${translate("INSIGHTS_SY_SUFFIX")}`}
        </h2>
      </div>
      {data.map((district) => (
        <DistrictInsightSection key={district.districtName} district={district} />
      ))}
    </div>
  );
}
